import type { AxiosInstance } from 'axios';
import type { NotificationFeed } from '@/types';
import baseAxios from '@/helpers/forms/axios';

interface NotificationsApi {
    fetchRecent: () => Promise<NotificationFeed>
    markAsRead: (notificationIds: string[]) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): NotificationsApi => ({
    fetchRecent: async (): Promise<NotificationFeed> => {
        const response = await axios.get<NotificationFeed>('/notifications/recent');
        return response.data;
    },
    markAsRead: async (notificationIds: string[]): Promise<void> => {
        await axios.put('/notifications/read', { notifications: notificationIds });
    },
});
